module.exports = __webpack_public_path__ + "static/img/Fuel-Poverty-Credits-Photos-Stephanie-Lacombe-1.278decf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Fuel-Poverty-Credits-Photos-Stephanie-Lacombe-1.jpg
// module id = BZAX
// module chunks = 0